import React from "react";
import { LoadingContainer } from "../../containers/LoadingContainer";
import WithLoading from "../organisms/LoadingHOC";
import Login from "../organisms/Login";

const LoginPage: React.FC = () => {
  const loading = LoadingContainer.useContainer();
  const LoginWithLoading = WithLoading(Login);

  return <LoginWithLoading isLoading={loading.isloading} loading={loading} />;
};

export default LoginPage;
